'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuVideo = require('@viskan/deku-video');

var _dekuVideo2 = _interopRequireDefault(_dekuVideo);

var _linkWrapper = require('../../link-wrapper');

var _linkWrapper2 = _interopRequireDefault(_linkWrapper);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getVideo = function getVideo(props) {
	var settings = {
		autoplay: props.autoplay,
		controls: props.controls,
		loop: props.loop,
		muted: props.muted,
		poster: props.poster,
		aspectRatio: props.aspectRatio,
		source: props.src
	};

	if (props.autoplay && props.muted && !props.controls && props.url) {
		var attributes = {
			href: props.url,
			'data-style-attr': 'VideoLink',
			class: props.styleClasses.VideoLink
		};

		return (0, _magicVirtualElement2.default)(
			_linkWrapper2.default,
			attributes,
			(0, _magicVirtualElement2.default)(_dekuVideo2.default, _extends({ styleClasses: props.styleClasses }, settings))
		);
	}

	return (0, _magicVirtualElement2.default)(_dekuVideo2.default, _extends({ styleClasses: props.styleClasses }, settings));
};

var render = function render(_ref) {
	var props = _ref.props;

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		null,
		getVideo(props)
	), props);
};

exports.default = { render: render };